import Swiper, {Autoplay, Navigation, Pagination, Scrollbar} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination, Scrollbar]);

export default class Partners {

    constructor() {
        if (document.getElementById('partners') !== null) {
            this.slider();
        }
    }

    slider() {
        new Swiper('#partners .swiper-container', {
            slidesPerView: 2,
            spaceBetween: 15,
            loop: true,
            autoplay: {
                delay: 3000
            },
            breakpoints: {
                576: {
                    slidesPerView: 4,
                },
                768: {
                    slidesPerView: 5,
                },
                992: {
                    slidesPerView: 6,
                },
                1200: {
                    slidesPerView: 8,
                    spaceBetween: 30,
                },
                1440: {
                    slidesPerView: 7,
                    spaceBetween: 30,
                }
            }
        });
    }
}
